import axios from "axios";
import useSWR from "swr";

export function useFetch(url) {
    const { data, error } = useSWR(url, url => axios.get(url).then(res => res.data))
    return { data, error, isLoading: !error && !data }
}